import { render, staticRenderFns } from "./PmMenu.vue?vue&type=template&id=125f6bd9"
import script from "./PmMenu.vue?vue&type=script&lang=js"
export * from "./PmMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports